import React from 'react';

export const USER_LOGGED_IN = 'firebaseContext/loggedIn';
export const USER_LOGGED_OUT = 'firebaseContext/loggedOut';
export const INITIALIZED = 'firebaseContext/initialized';
export const AUTH_READY = 'firebaseContext/authReady';

export const FirebaseStateContext = React.createContext(undefined);
export const FirebaseDispatchContext = React.createContext(undefined);

const initialState = {
    displayName: null,
    db: null,
    functions: null,
    uid: null,
    auth: null,
    admin: false,
    instructor: false,
    authReady: false,
};

const firebaseReducer = (state, action) => {
    console.debug(action);
    switch(action.type) {
        case INITIALIZED: {
            return {
                ...state,
                db: action.db,
                auth: action.auth,
                functions: action.functions
            }
        }
        case AUTH_READY:
            return {
                ...state,
                authReady: true,
            };
        case USER_LOGGED_IN:
            return {
                ...state,
                displayName: action.displayName,
                uid: action.uid,
                admin: action.admin,
                instructor: action.instructor,
                authReady: true,
            }
        case USER_LOGGED_OUT:
            return {
                ...state,
                displayName: null,
                uid: null,
                admin: false,
                instructor: false,
                authReady: true,
            }
        default:
            throw new Error(`Unhandled action type: ${action.type}`)
    }
}

export const FirebaseProvider = ({children}) => {
    const [state, dispatch] = React.useReducer(firebaseReducer, {...initialState}, undefined);

    return (
        <FirebaseStateContext.Provider value={state}>
            <FirebaseDispatchContext.Provider value={dispatch}>
                {children}
            </FirebaseDispatchContext.Provider>
        </FirebaseStateContext.Provider>
    )
}

export const useFirebaseState = () => {
    const context = React.useContext(FirebaseStateContext);
    if(undefined === context) {
        throw new Error('useFirebaseState must be used witin a FirebaseProvider')
    }
    return context;
}

export const useFirebaseDispatch = () => {
    const context = React.useContext(FirebaseDispatchContext);
    if(undefined === context) {
        throw new Error('useFirebaseDispatch must be used witin a FirebaseProvider')
    } else {
        return context;
    }
}